import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { GenericCardSpaces } from '@design-system/components/templates/generic-card/entities/generic-card.types';

const refundableImage = 'ilustra-check.png';
@Component({
  selector: 'app-free-cancellation',
  templateUrl: './free-cancellation.component.html',
  styleUrls: ['./free-cancellation.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FreeCancellationComponent {

  @Input() showDisabledAirlines: boolean = false;
  @Input() disabledAirlinesInCancellation: string[] = [];

  public readonly genericCardSpaces = GenericCardSpaces;

  get refundableImage(): string {
    return refundableImage;
  }

}
